import React, { useState } from 'react';
import useSignIn from './useSignIn';
import cls from './SignInPage.module.scss';
import { useTranslation } from 'react-i18next';
import getOC from 'src/utils/helpers/getOC';
import { NavLink } from 'react-router-dom';
import { PAGES_ENUM } from 'src/routes';
import debounce from '@mui/utils/debounce';
import { useForm } from 'react-hook-form';
import NoLayoutChangeLanguage from 'src/components/common/NoLayoutChangeLanguage/NoLayoutChangeLanguage';
import LoginInput from '../../UI/LoginInput';
import 'swiper/css';
import 'swiper/css/pagination';
import AuthorizationSwiper from '../../UI/AuthorizationSwiper/AuthorizationSwiper';
import CrmLoader from '../../components/UI/Loaders/CRMLoader';
import SupportBage from '../../UI/SupportBage/SupportBage';
import { ReactComponent as Logo } from 'src/assets/img/icons/profi-crm-new-login-logo.svg';

const SignInPage = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'sign-in' });
  const [isLoading, setIsLoading] = useState(false);
  const { handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      login: '',
      password: '',
    },
  });
  const { handleSignIn, canResetPassword } = useSignIn();
  const onSubmit = async (data: any) => {
    setIsLoading(true);
    await handleSignIn({
      login: data.login,
      password: data.password,
      device_os: getOC(),
      user_agent: navigator.userAgent,
    });

    setIsLoading(false);
  };

  const watchAllFields = watch();

  const isLoginHasValue = Boolean(watchAllFields?.login?.trim());
  const isPasswordHasValue = Boolean(watchAllFields?.password?.trim());

  return (
    <div className={cls['wrapper']}>
      <NoLayoutChangeLanguage />
      <AuthorizationSwiper />
      <div className={cls['form-wrapper']}>
        <Logo className={cls['swiper-logo']} />
        <form
          onSubmit={handleSubmit(debounce(onSubmit, 200))}
          className={cls['form']}
        >
          <p className={cls['form-title']}>{t('main-title')}</p>
          <div className={cls['input-wrapper']}>
            <LoginInput
              error={!isLoginHasValue}
              label={t('t-title-login')}
              value={watchAllFields.login}
              onChange={(e) => setValue('login', e.target.value)}
            />
          </div>
          <div className={cls['input-wrapper']}>
            <LoginInput
              label={t('t-title-password')}
              value={watchAllFields.password}
              error={!isPasswordHasValue}
              onChange={(e) => setValue('password', e.target.value)}
              type="password"
            />
          </div>

          <button
            type="submit"
            className={`auth-button ${cls['button']}`}
            disabled={!isLoginHasValue || !isPasswordHasValue || isLoading}
            data-qa-selector="submit-button"
          >
            {isLoading ? <CrmLoader size={30} /> : t('button')}
            {canResetPassword && (
              <NavLink to={PAGES_ENUM.RESET_PASSWORD} className={cls['link']}>
                {t('t-title-forgot-password')}
              </NavLink>
            )}
          </button>
        </form>
        <SupportBage />
      </div>
    </div>
  );
};
export default SignInPage;
